//@ts-check
import { CacheHolder } from './CacheHolder';

/**
 * @template T
 */
export class ExpireCacheHandler {
  /**
   * @param {number} expireMS
   * @param {number} size
   */
  constructor(expireMS, size = undefined) {
    /** @type {CacheHolder<T>} */
    this._byId = new CacheHolder(size);
    this._expired = new Map();
    this._expireMS = expireMS;
    this._handler = [];
  }

  /**
   * @param {string|number} key 
   * @return {T}
   */
  get(key) {
    key = String(key);
    const expired = this._expired.get(key);
    if (expired == null) {
      return undefined;
    }
    if (expired <= Date.now()) {
      this.trigger('expired', this._byId.get(key));
      this.delete(key);
    }
    return this._byId.get(key);
  }

  keys() {
    return this._byId.keys();
  }

  /**
   * @param {string|number} key
   * @param {T} value
   */
  set(key, value) {
    key = String(key);
    this._byId.set(key, value);
    this._expired.set(key, Date.now() + this._expireMS);
  }

  /**
   * @param {string|number} id 
   */
  delete(id) {
    id = String(id);
    this._byId.delete(id);
    this._expired.delete(id);
  }

  has(key) {
    key = String(key);
    const expired = this._expired.get(key);
    if (expired == null) {
      return false;
    }
    if (expired <= Date.now()) {
      this.delete(key);
    }
    return this._byId.has(key);
  }

  clear() {
    this._byId.clear();
    this._expired = new Map();
  }

  /**
 * @param {string} ev 
 * @param {Function} fn 
 */
  on(ev, fn) {
    this._handler[ev] = this._handler[ev] || [];
    this._handler[ev].push(fn);
  }

  /**
   * @param {string} ev 
   * @param  {...any} args 
   */
  trigger(ev, ...args) {
    const fns = this._handler[ev] || [];
    fns.forEach(fn => {
      fn(...args);
    });
  }

  /**
   * @param {string} ev 
   * @param {Function} fn 
   */
  off(ev, fn) {
    if (fn) {
      const fns = this._handler[ev];
      const index = fns.findIndex(f => fn === f);
      fns.splice(index, 1);
    } else {
      delete this._handler[ev];
    }
  }
}
